export default __webpack_public_path__ + "static/media/icon-duration-grey.128d097a.svg";